export default __webpack_public_path__ + "static/media/by.73704ff5.png";